import AsyncStorage from "@react-native-community/async-storage";


export default function Storage(key: string) {
    return {
        save: async (value: any) => {
            try {
                if (value !== undefined && value !== null) {
                    const jsonValue = JSON.stringify(value)
                    AsyncStorage.setItem(key, jsonValue)
                }
            } catch (e) {
                console.error(e);
            }
        },
        load: async () => {
            try {
                const jsonValue = await AsyncStorage.getItem(key)
                if (jsonValue != null)
                    return JSON.parse(jsonValue)
                else return null

            } catch (e) {
                console.error(e);
            }
        },
        remove: async () => {
            try {
                await AsyncStorage.removeItem(key)
            } catch (e) {
                console.error(e);
            }
        },
    }
}